// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bnuasdYlF8pu_GA6ACIR .lnJ9m0wpQ3j4_g1RDA3Q {
    transition: opacity 0.3s ease-in-out;
}

.efULKs6ML0ZFdBcJG1lP {
    transition: transform 0.3s ease-in-out;
}

.wIpy_e0HAhax0R9dU23w {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    background-color: rgba(0, 0, 0, 0.85);
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: LvM63hL8uw5SNpyK5guj 0.3s ease-in-out;
    padding: 1rem;
}

@keyframes LvM63hL8uw5SNpyK5guj {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.kfxL5JZem0AUnZsxj6iM {
    position: relative;
    background-color: white;
    border-radius: 0.5rem;
    width: calc(35% - 1rem);
}

.anKcJQFdCPZDIuG5SBQQ {
    padding-top: clamp(1.25rem, 1vw + 1.5rem, 2.5rem);
    padding-bottom: 3rem;
}

.p6EWUaH9109_ZiSou4fd {
    max-width: 50rem;
    text-wrap: balance;
    line-height: 150%;
    font-size: clamp(1.5rem, 1vw + 1rem, 2.5rem);
    padding-bottom: clamp(0.875rem, 1vw + 1rem, 2.5rem);
    margin: 0;
    display: flex;
    flex-direction: column;
}

.dsWePAifXxYuxXSVzifn {
    width: 50%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 1rem;
    filter: grayscale(100%);
}

.p6EWUaH9109_ZiSou4fd span:first-child {
    animation: zqXYaV1Zw9uvQ3G_u_LN 0.5s ease-in-out 0.25s backwards;
}

.p6EWUaH9109_ZiSou4fd span:nth-child(2) {
    animation: zqXYaV1Zw9uvQ3G_u_LN 0.5s ease-in-out 0.5s backwards;
}



@keyframes zqXYaV1Zw9uvQ3G_u_LN {
    from {
        transform: translateY(1rem);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.FcWH6oTP9FKFisVNmaXK {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 4rem;
}

.TgXCfZF2fifgP09rhHFk {
    position: absolute;
    width: 16rem;
    top: -11rem;
    right: -5rem;
    z-index: 2;
    animation: A4Nfw8Kn8mEBEPRbF9yD 0.5s ease-in-out 1.25s backwards;
}

.l90fPlLQHXDREH0vm5zA {
    width: 100%;
    padding: 2rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.l90fPlLQHXDREH0vm5zA h2 {
    margin: 0;
    font-size: clamp(0.875rem, 1vw + 0.25rem, 1.5rem);
}

.tVhUZHpHsYMUFvdwmBtL {
    font-size: clamp(0.75rem, 1vw - 0.25rem, 1rem);
}

.urHUj2XlLkxnhfk1ueFn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.urHUj2XlLkxnhfk1ueFn label,
.urHUj2XlLkxnhfk1ueFn input {
    width: 100%;
}

.Y4OqmUZWj_9T7g7wRLcB label,
.Y4OqmUZWj_9T7g7wRLcB input {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);
}

.Y4OqmUZWj_9T7g7wRLcB {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.aUpbTx10lpy8sCcYuLKy {
    width: 100%;
}

.aUpbTx10lpy8sCcYuLKy .FcWH6oTP9FKFisVNmaXK {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.jXOCFjs8LqpNVIrzCi99 {
    width: 100%;
    height: 0.5rem;
    border-radius: 1rem;
    background: #D3DAFF;
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.MH1jpysUhS9jstBjq2ds {
    width: 80%;
    height: 0.5rem;
    background-color: #4F67F3;
    border-radius: 0.5rem;
}

.MH1jpysUhS9jstBjq2ds.HDcAX5vJc8vtG5i_D9B5 {
    width: 16.66%;
}

.PIfXyIFkG0ouuAiUWmJX {
    color: rgba(0, 0, 0, 0.75);
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}

.yDwg2VvA_FCVBY9b7zDy {
    color: rgba(0, 0, 0, 0.50);
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.HRjwsvmOZjViMHVhVdHq {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.HRjwsvmOZjViMHVhVdHq img:first-child {
    margin-left: 0;
}

.HRjwsvmOZjViMHVhVdHq img {
    width: 2.5rem;
    height: 2.5rem;
    margin-left: -0.75rem;
}

.BXiidozrx30LBDaj273h {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 2.5rem;
    border: 2px solid white;
    background-color: #4F67F3;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: 500;
    font-size: 0.65rem;
    margin-left: -0.75rem;
    box-sizing: border-box;
}

.jH3KKyXUh9ZFKJby0LXT {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
}

.qicZNHDfpBkX0B8Hn5hc {
    color: rgba(0, 0, 0, 0.50);
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 0.71963rem */
}

.Bn6GC1bhOG0ktgeqPWMk,
.Bn6GC1bhOG0ktgeqPWMk span {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);;
}

.iyhE7q3hz6rsfUCrTUZd {
    transition: all 0.3s ease-in-out;
}

.Bn6GC1bhOG0ktgeqPWMk:hover .iyhE7q3hz6rsfUCrTUZd,
.vQg4tf0hsPvUcbIdaLVB:hover .iyhE7q3hz6rsfUCrTUZd {
    transform: translateX(0.5rem);
}

.vQg4tf0hsPvUcbIdaLVB,
.vQg4tf0hsPvUcbIdaLVB span {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem) !important;
}

.m7uJYk6ViAYDVXOgUgbx {
    display: flex;
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0;
    padding: 0;
}

.OSo1wwcJ1jEz_0W40v7e {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 2rem 0;
    text-align: center;
}

.Z1Rb3l9IFbBxh8vArL1i {
    color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: LvM63hL8uw5SNpyK5guj 0.5s ease-in-out;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(220, 38, 38, 0.1);
}

.grWW1bljpDnT98ZErFof {
    font-size: 52px;
    color: #dc2626;
}

.C3_onSaQQJuoo7z7Malv {
    margin: 0;
    font-size: clamp(1.25rem, 1vw + 0.5rem, 1.75rem);
    font-weight: 700;
    color: rgba(0, 0, 0, 0.9);
}

.UXmSjc5haM6OrzM_7nXk {
    font-size: clamp(0.875rem, 1vw - 0.25rem, 1rem);
    color: rgba(0, 0, 0, 0.75);
    line-height: 1.6;
    margin: 0;
    max-width: 100%;
}

@media screen and (max-width: 1375px) {
    .kfxL5JZem0AUnZsxj6iM {
        width: 50%;
        max-height: 90vh;
        overflow-y: none;
    }

    .DbJZ5y2HCXYXa7DHqyt5 {
        display: block;
    }

    .l90fPlLQHXDREH0vm5zA {
        width: 100%;
        box-sizing: border-box;
        margin-top: 1rem;
    }

    .urHUj2XlLkxnhfk1ueFn {
        flex-wrap: wrap;
    }

    .FcWH6oTP9FKFisVNmaXK {
        gap: 1rem;
    }

    .FcWH6oTP9FKFisVNmaXK>div {
        width: 100%;
    }

    .FcWH6oTP9FKFisVNmaXK>div:nth-child(2) p {
        text-align: right;
    }
}


@media screen and (max-width: 1024px) {
    .kfxL5JZem0AUnZsxj6iM {
        width: 70%;
        max-height: 90vh;
        overflow-y: none;
    }

    .DbJZ5y2HCXYXa7DHqyt5 {
        display: block;
    }

    .l90fPlLQHXDREH0vm5zA {
        width: 100%;
        box-sizing: border-box;
        margin-top: 1rem;
    }

    .urHUj2XlLkxnhfk1ueFn {
        flex-wrap: wrap;
    }

    .FcWH6oTP9FKFisVNmaXK {
        gap: 1rem;
    }

    .FcWH6oTP9FKFisVNmaXK>div {
        width: 100%;
    }

    .FcWH6oTP9FKFisVNmaXK>div:nth-child(2) p {
        text-align: right;
    }
}


@media screen and (max-width: 768px) {
    .kfxL5JZem0AUnZsxj6iM {
        width: 100%;
        max-height: 90vh;
        overflow-y: none;
    }

    .DbJZ5y2HCXYXa7DHqyt5 {
        display: block;
    }

    .l90fPlLQHXDREH0vm5zA {
        width: 100%;
        box-sizing: border-box;
        margin-top: 1rem;
    }

    .urHUj2XlLkxnhfk1ueFn {
        flex-wrap: wrap;
    }

    .FcWH6oTP9FKFisVNmaXK {
        gap: 1rem;
    }

    .FcWH6oTP9FKFisVNmaXK > div {
        width: 100%;
    }

    .FcWH6oTP9FKFisVNmaXK > div:nth-child(2) p {
        text-align: right;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Popup/Popup.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gDAAkC;IAClC,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,iDAAiD;IACjD,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,4CAA4C;IAC5C,mDAAmD;IACnD,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gEAAqD;AACzD;;AAEA;IACI,+DAAoD;AACxD;;;;AAIA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gEAAmD;AACvD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,iDAAiD;AACrD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,eAAe;AACtC;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gDAAkC;IAClC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gDAAgD;IAChD,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".button .text {\n    transition: opacity 0.3s ease-in-out;\n}\n\n.icon {\n    transition: transform 0.3s ease-in-out;\n}\n\n.background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 101;\n    background-color: rgba(0, 0, 0, 0.85);\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    animation: fadeIn 0.3s ease-in-out;\n    padding: 1rem;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.modal {\n    position: relative;\n    background-color: white;\n    border-radius: 0.5rem;\n    width: calc(35% - 1rem);\n}\n\n.header {\n    padding-top: clamp(1.25rem, 1vw + 1.5rem, 2.5rem);\n    padding-bottom: 3rem;\n}\n\n.title {\n    max-width: 50rem;\n    text-wrap: balance;\n    line-height: 150%;\n    font-size: clamp(1.5rem, 1vw + 1rem, 2.5rem);\n    padding-bottom: clamp(0.875rem, 1vw + 1rem, 2.5rem);\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.picture {\n    width: 50%;\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    border-radius: 1rem;\n    filter: grayscale(100%);\n}\n\n.title span:first-child {\n    animation: slideInUp 0.5s ease-in-out 0.25s backwards;\n}\n\n.title span:nth-child(2) {\n    animation: slideInUp 0.5s ease-in-out 0.5s backwards;\n}\n\n\n\n@keyframes slideInUp {\n    from {\n        transform: translateY(1rem);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.row {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 4rem;\n}\n\n.arrow {\n    position: absolute;\n    width: 16rem;\n    top: -11rem;\n    right: -5rem;\n    z-index: 2;\n    animation: fade-in 0.5s ease-in-out 1.25s backwards;\n}\n\n.form-container {\n    width: 100%;\n    padding: 2rem;\n    border-radius: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.form-container h2 {\n    margin: 0;\n    font-size: clamp(0.875rem, 1vw + 0.25rem, 1.5rem);\n}\n\n.description {\n    font-size: clamp(0.75rem, 1vw - 0.25rem, 1rem);\n}\n\n.form-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\n.form-row label,\n.form-row input {\n    width: 100%;\n}\n\n.form label,\n.form input {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.wait-list {\n    width: 100%;\n}\n\n.wait-list .row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.progress-bar {\n    width: 100%;\n    height: 0.5rem;\n    border-radius: 1rem;\n    background: #D3DAFF;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n\n.progress {\n    width: 80%;\n    height: 0.5rem;\n    background-color: #4F67F3;\n    border-radius: 0.5rem;\n}\n\n.progress.other {\n    width: 16.66%;\n}\n\n.label {\n    color: rgba(0, 0, 0, 0.75);\n    font-family: Inter, sans-serif;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n}\n\n.hint {\n    color: rgba(0, 0, 0, 0.50);\n    font-family: Inter, sans-serif;\n    font-size: 0.75rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n.investors {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.investors img:first-child {\n    margin-left: 0;\n}\n\n.investors img {\n    width: 2.5rem;\n    height: 2.5rem;\n    margin-left: -0.75rem;\n}\n\n.other-invest {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 2.5rem;\n    border: 2px solid white;\n    background-color: #4F67F3;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: 500;\n    font-size: 0.65rem;\n    margin-left: -0.75rem;\n    box-sizing: border-box;\n}\n\n.investors-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.wait-list-number {\n    color: rgba(0, 0, 0, 0.50);\n    font-family: Inter, sans-serif;\n    font-size: 0.75rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 0.71963rem */\n}\n\n.submit,\n.submit span {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);;\n}\n\n.arrow-icon {\n    transition: all 0.3s ease-in-out;\n}\n\n.submit:hover .arrow-icon,\n.link:hover .arrow-icon {\n    transform: translateX(0.5rem);\n}\n\n.link,\n.link span {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem) !important;\n}\n\n.languages {\n    display: flex;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    margin: 0;\n    padding: 0;\n}\n\n.closed-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.5rem;\n    padding: 2rem 0;\n    text-align: center;\n}\n\n.closed-icon {\n    color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    animation: fadeIn 0.5s ease-in-out;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background-color: rgba(220, 38, 38, 0.1);\n}\n\n.closed-icon-icon {\n    font-size: 52px;\n    color: #dc2626;\n}\n\n.closed-title {\n    margin: 0;\n    font-size: clamp(1.25rem, 1vw + 0.5rem, 1.75rem);\n    font-weight: 700;\n    color: rgba(0, 0, 0, 0.9);\n}\n\n.closed-message {\n    font-size: clamp(0.875rem, 1vw - 0.25rem, 1rem);\n    color: rgba(0, 0, 0, 0.75);\n    line-height: 1.6;\n    margin: 0;\n    max-width: 100%;\n}\n\n@media screen and (max-width: 1375px) {\n    .modal {\n        width: 50%;\n        max-height: 90vh;\n        overflow-y: none;\n    }\n\n    .mobile {\n        display: block;\n    }\n\n    .form-container {\n        width: 100%;\n        box-sizing: border-box;\n        margin-top: 1rem;\n    }\n\n    .form-row {\n        flex-wrap: wrap;\n    }\n\n    .row {\n        gap: 1rem;\n    }\n\n    .row>div {\n        width: 100%;\n    }\n\n    .row>div:nth-child(2) p {\n        text-align: right;\n    }\n}\n\n\n@media screen and (max-width: 1024px) {\n    .modal {\n        width: 70%;\n        max-height: 90vh;\n        overflow-y: none;\n    }\n\n    .mobile {\n        display: block;\n    }\n\n    .form-container {\n        width: 100%;\n        box-sizing: border-box;\n        margin-top: 1rem;\n    }\n\n    .form-row {\n        flex-wrap: wrap;\n    }\n\n    .row {\n        gap: 1rem;\n    }\n\n    .row>div {\n        width: 100%;\n    }\n\n    .row>div:nth-child(2) p {\n        text-align: right;\n    }\n}\n\n\n@media screen and (max-width: 768px) {\n    .modal {\n        width: 100%;\n        max-height: 90vh;\n        overflow-y: none;\n    }\n\n    .mobile {\n        display: block;\n    }\n\n    .form-container {\n        width: 100%;\n        box-sizing: border-box;\n        margin-top: 1rem;\n    }\n\n    .form-row {\n        flex-wrap: wrap;\n    }\n\n    .row {\n        gap: 1rem;\n    }\n\n    .row > div {\n        width: 100%;\n    }\n\n    .row > div:nth-child(2) p {\n        text-align: right;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `bnuasdYlF8pu_GA6ACIR`,
	"text": `lnJ9m0wpQ3j4_g1RDA3Q`,
	"icon": `efULKs6ML0ZFdBcJG1lP`,
	"background": `wIpy_e0HAhax0R9dU23w`,
	"fadeIn": `LvM63hL8uw5SNpyK5guj`,
	"modal": `kfxL5JZem0AUnZsxj6iM`,
	"header": `anKcJQFdCPZDIuG5SBQQ`,
	"title": `p6EWUaH9109_ZiSou4fd`,
	"picture": `dsWePAifXxYuxXSVzifn`,
	"slideInUp": `zqXYaV1Zw9uvQ3G_u_LN`,
	"row": `FcWH6oTP9FKFisVNmaXK`,
	"arrow": `TgXCfZF2fifgP09rhHFk`,
	"fade-in": `A4Nfw8Kn8mEBEPRbF9yD`,
	"form-container": `l90fPlLQHXDREH0vm5zA`,
	"description": `tVhUZHpHsYMUFvdwmBtL`,
	"form-row": `urHUj2XlLkxnhfk1ueFn`,
	"form": `Y4OqmUZWj_9T7g7wRLcB`,
	"wait-list": `aUpbTx10lpy8sCcYuLKy`,
	"progress-bar": `jXOCFjs8LqpNVIrzCi99`,
	"progress": `MH1jpysUhS9jstBjq2ds`,
	"other": `HDcAX5vJc8vtG5i_D9B5`,
	"label": `PIfXyIFkG0ouuAiUWmJX`,
	"hint": `yDwg2VvA_FCVBY9b7zDy`,
	"investors": `HRjwsvmOZjViMHVhVdHq`,
	"other-invest": `BXiidozrx30LBDaj273h`,
	"investors-container": `jH3KKyXUh9ZFKJby0LXT`,
	"wait-list-number": `qicZNHDfpBkX0B8Hn5hc`,
	"submit": `Bn6GC1bhOG0ktgeqPWMk`,
	"arrow-icon": `iyhE7q3hz6rsfUCrTUZd`,
	"link": `vQg4tf0hsPvUcbIdaLVB`,
	"languages": `m7uJYk6ViAYDVXOgUgbx`,
	"closed-content": `OSo1wwcJ1jEz_0W40v7e`,
	"closed-icon": `Z1Rb3l9IFbBxh8vArL1i`,
	"closed-icon-icon": `grWW1bljpDnT98ZErFof`,
	"closed-title": `C3_onSaQQJuoo7z7Malv`,
	"closed-message": `UXmSjc5haM6OrzM_7nXk`,
	"mobile": `DbJZ5y2HCXYXa7DHqyt5`
};
export default ___CSS_LOADER_EXPORT___;
